import { APP_PATHS } from '@/constants';

export const BPC_BASE_PATH = `/products/${APP_PATHS.BPC_POC}`;

export const COMMON_GROUP_ID = { SUMMARY_PAGE: 'SummaryPage', STATUS_PAGE: 'StatusPage' };
